// extracted by mini-css-extract-plugin
export default {"container":"SyK2A","postMainActionContainer":"+jWT-","icon":"uO1s-","wrapper":"_3XUvn","postPageRevamp":"ayOAN","postMainActionWrapper":"vK3Aw"};